import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#202020"
        d="M4 17.5h16V13h2v6.5A1.5 1.5 0 0120.5 21h-17A1.5 1.5 0 012 19.5V13h2v4.5zM13 8.2v7.3h-2V8.2H7.4L12 3.5l4.6 4.7H13z"
      />
    </svg>
  )
}

export default Icon
